"use strict";

var _slicedToArray = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@netgum/utils");

var constants_1 = require("../constants");

var AccountFriendRecovery = /*#__PURE__*/function () {
  function AccountFriendRecovery(apiMethods, contract, device, state) {
    _classCallCheck(this, AccountFriendRecovery);

    this.apiMethods = apiMethods;
    this.contract = contract;
    this.device = device;
    this.state = state; //
  }

  _createClass(AccountFriendRecovery, [{
    key: "signAccountFriendRecovery",
    value: function signAccountFriendRecovery(accountAddress, deviceAddress, gasPrice) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result, friend, _yield$this$apiMethod, friends, nonce, gasFee, accountFriendRecovery, message;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = null;
                friend = this.state.accountAddress;
                _context.next = 4;
                return this.apiMethods.getAccountFriendRecovery(accountAddress);

              case 4:
                _yield$this$apiMethod = _context.sent;
                friends = _yield$this$apiMethod.friends;
                nonce = _yield$this$apiMethod.nonce;
                gasFee = _yield$this$apiMethod.gasFee;

                if (friends.indexOf(friend) !== -1) {
                  accountFriendRecovery = this.contract.accountFriendRecovery;
                  message = utils_1.abiEncodePacked('address', 'bytes', 'address', 'address', 'uint256', 'uint256', 'uint256')(accountFriendRecovery.address, accountFriendRecovery.getMethodSignature('recoverAccount'), accountAddress, deviceAddress, nonce, gasFee, gasPrice);
                  result = utils_1.anyToHex(this.device.signPersonalMessage(message), {
                    add0x: true
                  });
                }

                return _context.abrupt("return", result);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "collectAccountFriendSignature",
    value: function collectAccountFriendSignature(friendAddress, friendSignature) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var result, _this$state, deviceAddress, accountFriendRecovery, accountAddress, friends, nonce, gasFee, gasPrice, friendSignatures, _accountFriendRecovery, message, friendDevice, _yield$this$apiMethod2, state, type;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                result = false;
                _this$state = this.state, deviceAddress = _this$state.deviceAddress, accountFriendRecovery = _this$state.accountFriendRecovery;
                accountAddress = accountFriendRecovery.accountAddress, friends = accountFriendRecovery.friends, nonce = accountFriendRecovery.nonce, gasFee = accountFriendRecovery.gasFee, gasPrice = accountFriendRecovery.gasPrice, friendSignatures = accountFriendRecovery.friendSignatures;

                if (!(friends.indexOf(friendAddress) !== -1)) {
                  _context2.next = 13;
                  break;
                }

                _accountFriendRecovery = this.contract.accountFriendRecovery;
                message = utils_1.abiEncodePacked('address', 'bytes', 'address', 'address', 'uint256', 'uint256', 'uint256')(_accountFriendRecovery.address, _accountFriendRecovery.getMethodSignature('recoverAccount'), accountAddress, deviceAddress, nonce, gasFee, gasPrice);
                friendDevice = utils_1.recoverAddressFromPersonalMessage(message, friendSignature);
                _context2.next = 9;
                return this.apiMethods.getAccountDevice(friendAddress, friendDevice);

              case 9:
                _yield$this$apiMethod2 = _context2.sent;
                state = _yield$this$apiMethod2.state;
                type = _yield$this$apiMethod2.type;
                result = state === constants_1.AccountDeviceStates.Deployed && type === constants_1.AccountDeviceTypes.Owner;

              case 13:
                if (result) {
                  accountFriendRecovery.friendSignatures = Object.assign({}, friendSignatures, _defineProperty({}, friendAddress, friendSignature));
                  this.state.accountFriendRecovery$.next(Object.assign({}, accountFriendRecovery));
                }

                return _context2.abrupt("return", result);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "startAccountFriendRecovery",
    value: function startAccountFriendRecovery(accountAddress) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var accountFriendRecovery;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.apiMethods.getAccountFriendRecovery(accountAddress);

              case 2:
                accountFriendRecovery = _context3.sent;
                this.state.accountFriendRecovery$.next(Object.assign({
                  accountAddress: accountAddress,
                  friendSignatures: {}
                }, accountFriendRecovery));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "cancelAccountFriendRecovery",
    value: function cancelAccountFriendRecovery() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.state.accountFriendRecovery$.next(null);

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "submitAccountFriendRecovery",
    value: function submitAccountFriendRecovery() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this$state$accountFr, accountAddress, gasPrice, friendSignatures, guardianSignature, friends, signatures, hash;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this$state$accountFr = this.state.accountFriendRecovery, accountAddress = _this$state$accountFr.accountAddress, gasPrice = _this$state$accountFr.gasPrice, friendSignatures = _this$state$accountFr.friendSignatures, guardianSignature = _this$state$accountFr.guardianSignature;
                friends = [];
                signatures = [];
                Object.entries(friendSignatures).forEach(function (_ref) {
                  var _ref2 = _slicedToArray(_ref, 2),
                      friend = _ref2[0],
                      signature = _ref2[1];

                  friends.push(friend);
                  signatures.push(signature);
                });
                _context5.next = 6;
                return this.apiMethods.submitAccountFriendRecovery(accountAddress, friends, signatures, gasPrice, guardianSignature);

              case 6:
                hash = _context5.sent;

                if (hash) {
                  this.state.accountFriendRecovery$.next(null);
                }

                return _context5.abrupt("return", hash);

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }]);

  return AccountFriendRecovery;
}();

exports.AccountFriendRecovery = AccountFriendRecovery;